import { CellClickedEvent, ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType, AgGridExportType, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'

export function incidentsGridColumnDefs(
    onAttachmentsClicked: (event: CellClickedEvent) => void
): (ColDef | ExportedColGroupDef)[] {
    return [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('incidents.grid.groups.incidentData'),
            children: [
                {
                    headerName: i18n.tc('incidents.grid.incidentLabel'),
                    field: 'incLabel',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    suppressSizeToFit: true,
                    width: 130
                },
                {
                    headerName: i18n.tc('incidents.grid.laboratory'),
                    field: 'laboratory.labName',
                    type: AgGridColumnType.LABORATORIES,
                    exportType: AgGridExportType.TEXT,
                    suppressSizeToFit: true,
                    width: 160
                },
                {
                    headerName: i18n.tc('incidents.grid.severity'),
                    colId: 'incidentSeverity.id',
                    field: 'incidentSeverity',
                    type: AgGridColumnType.INCIDENT_SEVERITY,
                    exportField: 'incidentSeverity.name',
                    exportType: AgGridExportType.TEXT,
                    minWidth: 100,
                    flex: 1
                },
                {
                    headerName: i18n.tc('incidents.grid.incidentOrigin'),
                    field: 'incidentOrigin.id',
                    type: 'incidentOrigin',
                    exportField: 'incidentOrigin.name',
                    exportType: AgGridExportType.TEXT,
                    suppressSizeToFit: true,
                    width: 160
                },
                {
                    headerName: i18n.tc('incidents.grid.incidentType'),
                    field: 'incidentType.id',
                    type: 'incidentType',
                    exportField: 'incidentType.name',
                    exportType: AgGridExportType.TEXT,
                    suppressSizeToFit: true,
                    width: 260
                },
                {
                    headerName: i18n.tc('incidents.grid.entity'),
                    type: AgGridColumnType.INCIDENT_CORE_ENTITY,
                    field: 'coreEntity',
                    exportField: 'coreEntity.translatedName',
                    exportType: AgGridExportType.TEXT,
                    minWidth: 110,
                    flex: 1
                },
                {
                    headerName: i18n.tc('incidents.grid.entityId'),
                    field: 'entityExternalId',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    sortable: false,
                    filterParams: {
                        newRowsAction: 'keep',
                        caseSensitive: true,
                        filterOptions: ['equals'],
                        suppressAndOrCondition: true
                    },
                    suppressSizeToFit: true,
                    width: 170
                },
                {
                    headerName: i18n.tc('incidents.grid.attachments'),
                    headerTooltip: i18n.tc('incidents.grid.attachments'),
                    headerComponentParams: {
                        template: buildIconHeaderTemplate('far fa-paperclip')
                    },
                    field: 'attachments',
                    type: AgGridColumnType.ATTACHMENT_COUNT,
                    exportType: AgGridExportType.INTEGER,
                    onCellClicked: onAttachmentsClicked,
                    filter: false,
                    width: 55
                },
                {
                    headerName: i18n.tc('incidents.grid.notified'),
                    colId: 'notifiedPersonnelList.id',
                    cellRenderer: ({ data }: ICellRendererParams) => {
                        let value = ''
                        if (data?.notifiedPersonnelList) {
                            for (const notifiedPersonnel of data.notifiedPersonnelList) {
                                value += notifiedPersonnel.fullName + '<br/>'
                            }
                        }
                        return value
                    },
                    hide: false,
                    sortable: false,
                    filter: false,
                    suppressSizeToFit: true,
                    width: 170
                }
                // TODO: implementar esta funcionalidad en el backend
                /*
                {
                    headerName: i18n.tc('incidents.grid.reportGenerated'),
                    field: 'reportGenerated',
                    type: AgGridColumnType.DATE,
                    hide: true,
                    suppressSizeToFit: true,
                    width: 50
                },
                {
                    headerName: i18n.tc('incidents.grid.readByNotified'),
                    field: 'readByNotified',
                    type: AgGridColumnType.DATE,
                    hide: true,
                    suppressSizeToFit: true,
                    width: 50
                }
                */
            ]
        },
        {
            headerName: i18n.tc('incidents.grid.groups.openingData'),
            children: [
                {
                    headerName: i18n.tc('incidents.grid.incidentDate'),
                    field: 'incidentDate',
                    type: AgGridColumnType.DATETIME,
                    exportType: AgGridExportType.DATETIME,
                    suppressSizeToFit: true,
                    width: 150
                },
                {
                    headerName: i18n.tc('incidents.grid.openingDate'),
                    field: 'openingDate',
                    type: AgGridColumnType.DATETIME,
                    exportType: AgGridExportType.DATETIME,
                    suppressSizeToFit: true,
                    width: 140
                },
                {
                    headerName: i18n.tc('incidents.grid.openedBy'),
                    colId: 'openedBy.normalizedFullName',
                    field: 'openedBy.fullName',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    suppressSizeToFit: true,
                    width: 180
                }
            ]
        },
        {
            headerName: i18n.tc('incidents.grid.groups.closingData'),
            children: [
                {
                    headerName: i18n.tc('incidents.grid.closingDate'),
                    field: 'closingDate',
                    type: AgGridColumnType.DATETIME,
                    exportType: AgGridExportType.DATETIME,
                    suppressSizeToFit: true,
                    width: 130
                },
                {
                    headerName: i18n.tc('incidents.grid.closedBy'),
                    colId: 'closedBy.normalizedFullName',
                    field: 'closedBy.fullName',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    suppressSizeToFit: true,
                    width: 180
                }
            ]
        }
    ]
}
